// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const redeterminationEntryPointTypeEnum = {
  REDETERMINATION: "REDETERMINATION",
} as const;

export type RedeterminationEntryPointTypeEnumKey =
  (typeof redeterminationEntryPointTypeEnum)[keyof typeof redeterminationEntryPointTypeEnum];

export const redeterminationTypeEnum = {
  VANCE_REDETERMINATION: "VANCE_REDETERMINATION",
} as const;

export type RedeterminationTypeEnumKey =
  (typeof redeterminationTypeEnum)[keyof typeof redeterminationTypeEnum];

export type Redetermination = {
  /**
   * @type string
   */
  entryPointType: RedeterminationEntryPointTypeEnumKey;
  /**
   * @type string
   */
  memberId: string;
  /**
   * @description The date redetermination is due.
   * @type string, date
   */
  redeterminationDate: string;
  /**
   * @type string
   */
  state: string;
  /**
   * @type string
   */
  type: RedeterminationTypeEnumKey;
  /**
   * @type string
   */
  workspaceId: string;
};
